function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactDropzone from 'react-dropzone';
import classnames from 'classnames';
import { Button } from '@appfolio/react-gears';

var DropZone = /*#__PURE__*/function (_Component) {
  _inherits(DropZone, _Component);

  var _super = _createSuper(DropZone);

  function DropZone() {
    _classCallCheck(this, DropZone);

    return _super.apply(this, arguments);
  }

  _createClass(DropZone, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          buttonLabel = _this$props.buttonLabel,
          dragLabel = _this$props.dragLabel,
          props = _objectWithoutProperties(_this$props, ["children", "className", "buttonLabel", "dragLabel"]);

      var classNames = classnames('d-flex flex-column flex-sm-row justify-content-center align-items-center p-4 border-secondary', className);
      var noDragAndDropProps = {
        onDragEnter: function onDragEnter(e) {
          e.stopPropagation();
        },
        onDragLeave: function onDragLeave(e) {
          e.stopPropagation();
        }
      };
      return /*#__PURE__*/React.createElement(ReactDropzone, props, function (_ref) {
        var getInputProps = _ref.getInputProps,
            getRootProps = _ref.getRootProps,
            isDragActive = _ref.isDragActive,
            open = _ref.open;
        return /*#__PURE__*/React.createElement("div", _extends({}, getRootProps({
          id: 'react-dropzone'
        }), {
          className: classnames(classNames, {
            'border-success': isDragActive,
            'bg-success': isDragActive
          }),
          style: {
            borderWidth: '2px',
            borderStyle: 'dashed'
          }
        }), children || /*#__PURE__*/React.createElement(Fragment, null, dragLabel && /*#__PURE__*/React.createElement("b", noDragAndDropProps, dragLabel), dragLabel && buttonLabel && /*#__PURE__*/React.createElement("p", _extends({
          className: "m-0 mx-4"
        }, noDragAndDropProps), "or"), buttonLabel && /*#__PURE__*/React.createElement(Button, _extends({
          onClick: function onClick(e) {
            e.preventDefault();
            open();
          }
        }, noDragAndDropProps), buttonLabel), /*#__PURE__*/React.createElement("input", getInputProps())));
      });
    }
  }]);

  return DropZone;
}(Component);

DropZone.propTypes = _objectSpread({}, ReactDropzone.propTypes, {
  children: PropTypes.node,
  className: PropTypes.string,
  buttonLabel: PropTypes.node,
  dragLabel: PropTypes.node,
  onDrop: PropTypes.func.isRequired,
  maxSize: PropTypes.number
});
DropZone.defaultProps = _objectSpread({}, ReactDropzone.defaultProps, {
  buttonLabel: 'Choose Files to Add',
  dragLabel: 'Drag Files Here',
  maxSize: 30 * 1024 * 1024
});
DropZone.displayName = "DropZone";
export { DropZone as default };